import { useTranslation } from "react-i18next";
import "./RiBatch.scss";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import newRequest from '../../../utils/newRequest';
import { ScaleLoader } from "react-spinners";
import { motion } from "framer-motion";
import numeral from "numeral";
import { MdClose, MdDelete, MdSave, } from 'react-icons/md';
import { IoClose, IoDocumentTextSharp } from 'react-icons/io5';
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import EmailComponent from "../../../components/emailComponent/EmailComponent";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports";
import {
    Table,
    TablePagination,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
} from "@mui/material";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import { IoIosRefresh } from "react-icons/io";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent";
import { LuRefreshCcw, LuRefreshCcwDot } from "react-icons/lu";
import { showToast } from "../../../toastService";
import { calculateBasePercentage, calculatePercentage, formatNumber, formatStringToNumberV2, logData } from "../../../utils/genericFunctions";
import { BiLogoRedux } from "react-icons/bi";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy";
import Select from "react-select";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect";

const RiBatch = () => {
    const { t } = useTranslation();
    const [isProcessing, setIsProcessing] = useState(false);
    const { currentUser } = useSelector((state) => state.user);
    const { currentTheme } = useSelector((state) => state.theme);
    const [isLoading, setIsLoading] = useState(false);
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const navigate = useNavigate();
    const { docid } = useParams();
    const [batchData, setBatchData] = useState(null);
    const [batchLinesData, setBatchLinesData] = useState([]);
    const [selectedBatchLine, setSelectedBatchLine] = useState(null);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [confirmationActiontext, setConfirmationActiontext] = useState("");
    const [documentEnabled, setDocumentEnabled] = useState("Y");
    const [saveEnabled, setSaveEnabled] = useState("Y");
    const [nextAction, setNextAction] = useState("Validate");
    const [isConfettiActive, setIsConfettiActive] = useState(false);
    // email component 
    const [emailDialogOpen, setEmailDialogOpen] = useState(false);
    const [emailData, setEmailData] = useState(null);
    const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
    const [figuresToShow, setFiguresToShow] = useState("ri");

    const [allocatedPercent, setAllocatedPercent] = useState(0);
    const [allocatedFcSi, setAllocatedFcSi] = useState(0);
    const [allocatedLcSi, setAllocatedLcSi] = useState(0);
    const [allocatedFcPremium, setAllocatedFcPremium] = useState(0);
    const [allocatedLcPremium, setAllocatedLcPremium] = useState(0);

    const [osFlag, setOsFlag] = useState("Y");
    const [osPercent, setOsPercent] = useState(0);
    const [osFcSi, setOsFcSi] = useState(0);
    const [osLcSi, setOsLcSi] = useState(0);
    const [osFcPremium, setOsFcPremium] = useState(0);
    const [osLcPremium, setOsLcPremium] = useState(0);


    const [retentionPercent, setRetentionPercent] = useState(0);
    const [retentionFcSi, setRetentionFcSi] = useState(0);
    const [retentionLcSi, setRetentionLcSi] = useState(0);
    const [retentionFcPremium, setRetentionFcPremium] = useState(0);
    const [retentionLcPremium, setRetentionLcPremium] = useState(0);

    const [cqsPercent, setCqsPercent] = useState(0);
    const [cqsFcSi, setCqsFcSi] = useState(0);
    const [cqsLcSi, setCqsLcSi] = useState(0);
    const [cqsFcPremium, setCqsFcPremium] = useState(0);
    const [cqsLcPremium, setCqsLcPremium] = useState(0);

    const [qsPercent, setQsPercent] = useState(0);
    const [qsFcSi, setQsFcSi] = useState(0);
    const [qsLcSi, setQsLcSi] = useState(0);
    const [qsFcPremium, setQsFcPremium] = useState(0);
    const [qsLcPremium, setQsLcPremium] = useState(0);

    const [surplusPercent, setSurplusPercent] = useState(0);
    const [surplusFcSi, setSurplusFcSi] = useState(0);
    const [surplusLcSi, setSurplusLcSi] = useState(0);
    const [surplusFcPremium, setSurplusFcPremium] = useState(0);
    const [surplusLcPremium, setSurplusLcPremium] = useState(0);

    const [facPercent, setFacPercent] = useState(0);
    const [facFcSi, setFacFcSi] = useState(0);
    const [facLcSi, setFacLcSi] = useState(0);
    const [facFcPremium, setFacFcPremium] = useState(0);
    const [facLcPremium, setFacLcPremium] = useState(0);
    const [riCategories, setRiCategories] = useState([]);


    const fetchRiCategories = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "RI Categories" });
            const options = res.data.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));
            setRiCategories(options);
        } catch (error) {
            console.error("Error fetching risk functions :", error);
        }
    };

    const handleConfirm = async () => {
        try {
            if (confirmDialogAction === "reallocateRi") {
                const res = await newRequest.post("/rialloc/allocate", {
                    policy_docid: batchData?.ri_policy_docid,
                    batch_docid: docid,
                    risk_catg: batchData?.ri_risk_catg
                });
                logData("sherehe", res.data);
                await fetchBatch(res.data?.doc?._id, true);
                navigate(`/ri/${res.data?.doc?._id}`, { replace: true });
                showToast(`Reallocated!`, "success");
            } else if (confirmDialogAction === "deleteLine") {
                setIsProcessing(true);
                const res = await newRequest.delete(`/ribatch/delLine/${selectedBatchLine?._id}`);
                setIsProcessing(false);
                if (res.data?.msg === "deleted") {
                    setBatchLinesData((prev) => prev.filter(line => line?._id !== selectedBatchLine?._id));
                    showToast("Deleted!", "success");
                } else {
                    showToast("Error removing!", "error");
                }
            }
        } catch (err) {
            console.log(err);
        }
        setIsConfirmDialogOpen(false);
    };


    const saveRecord = async (e) => {
        try {

            // update batch header
            await newRequest.put(`/ribatch/upd/${batchData?._id}`, { ri_risk_catg: batchData?.ri_risk_catg });

            // update batch lines
            const changedLines = batchLinesData.filter((obj) => obj.changed_xx === "Y");
            // Loop through each object in the array
            for (let i = 0; i < changedLines.length; i++) {
                const formattedLine = {
                    ...changedLines[i],
                    line_si_fc: formatStringToNumberV2(changedLines[i].line_si_fc, 2),
                    line_si_lc: formatStringToNumberV2(changedLines[i].line_si_lc, 2),
                    line_premium_fc: formatStringToNumberV2(changedLines[i].line_premium_fc, 2),
                    line_premium_lc: formatStringToNumberV2(changedLines[i].line_premium_lc, 2),
                    line_rate: formatStringToNumberV2(changedLines[i].line_rate, 6),
                };
                await newRequest.put(`/ribatch/updLine/${changedLines[i]?._id}`, formattedLine);
            }

            setNotifyDialogTitle(t('success'));
            setNotifyDialogText(`Successfully saved!`);
            setIsNotifyDialogOpen(true);
        } catch (err) {
            console.log(err);
        }
    };


    const fetchBatch = async (docId, firstTime = false) => {
        try {
            if (firstTime) { setIsLoading(true); }
            setBatchLinesData([]);
            const res = await newRequest.get(`/ribatch/find/${docId}`);
            if (res.data) {
                setBatchData(res.data);
                // console.log(`Lines ${JSON.stringify(res.data, null, 2)}`);
                const formattedLines = res.data?.batch_lines?.lines?.map(line => ({
                    ...line,
                    line_si_fc: formatNumber(line.line_si_fc, 2),
                    line_si_lc: formatNumber(line.line_si_lc, 2),
                    line_premium_fc: formatNumber(line.line_premium_fc, 2),
                    line_premium_lc: formatNumber(line.line_premium_lc, 2),
                    line_rate: formatNumber(line.line_rate, 6),
                }));
                setBatchLinesData(formattedLines);
            }
            if (res.data.ri_status === "New") {
                await fetchRiCategories();
            }
        } catch (err) {
            console.log(err);
        } finally {
            if (firstTime) {
                setIsLoading(false);
            }
        }
    };

    const handleLineInputChange = (e, id, field) => {
        try {
            const newData = [...batchLinesData];
            const index = newData.findIndex(smi => smi._id === id);
            if (index !== -1) {
                newData[index][field] = e.target.value;
                setBatchLinesData(newData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleLineBlur = (id, field) => {
        try {
            const updatedData = [...batchLinesData];
            const index = updatedData.findIndex(smi => smi._id === id);

            if (index !== -1) {
                const value = formatStringToNumberV2(updatedData[index][field]);
                updatedData[index][field] = formatNumber(value)
                updatedData[index]["changed_xx"] = "Y";
                // CALCULATE PERCENTAGE IF SUM INSURED IS CHANGED
                if (["line_si_lc"].includes(field)) {
                    const allocationPercentage = Number(parseFloat(calculateBasePercentage(batchData?.ri_si_lc, value).toFixed(6)));
                    // console.log(`allocationPercentage ${allocationPercentage}`);
                    const allocatedPremiumFc = calculatePercentage(batchData?.ri_premium_fc, allocationPercentage);
                    const allocatedPremiumLc = calculatePercentage(batchData?.ri_premium_lc, allocationPercentage);
                    // console.log(`allocatedPremiumFc ${allocatedPremiumFc}`);
                    // console.log(`allocatedPremiumLc ${allocatedPremiumLc}`);
                    updatedData[index]["line_rate"] = allocationPercentage;
                    updatedData[index]["line_premium_fc"] = formatNumber(allocatedPremiumFc);
                    updatedData[index]["line_premium_lc"] = formatNumber(allocatedPremiumLc);
                }
                // GET TOTAL ALLOCATED
                setBatchLinesData(updatedData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        const {
            totalAllocatedFcSi,
            totalAllocatedLcSi,
            totalAllocatedFcPremium,
            totalAllocatedLcPremium,
        } = batchLinesData
            ?.reduce(
                (totals, line) => {
                    totals.totalAllocatedFcSi += formatStringToNumberV2(line.line_si_fc) || 0;
                    totals.totalAllocatedLcSi += formatStringToNumberV2(line.line_si_lc) || 0;
                    totals.totalAllocatedFcPremium += formatStringToNumberV2(line.line_premium_fc) || 0;
                    totals.totalAllocatedLcPremium += formatStringToNumberV2(line.line_premium_lc) || 0;
                    return totals;
                },
                {
                    totalAllocatedFcSi: 0,
                    totalAllocatedLcSi: 0,
                    totalAllocatedFcPremium: 0,
                    totalAllocatedLcPremium: 0,
                }
            ) || {};

        const allocationPercentage = Number(parseFloat(calculateBasePercentage(batchData?.ri_si_lc, totalAllocatedLcSi).toFixed(6)));
        setAllocatedPercent(allocationPercentage);
        setAllocatedFcSi(totalAllocatedFcSi);
        setAllocatedLcSi(totalAllocatedLcSi);
        setAllocatedFcPremium(totalAllocatedFcPremium);
        setAllocatedLcPremium(totalAllocatedLcPremium);

        // console.log(`batchData?.ri_si_fc ... ${batchData?.ri_si_fc}`);
        // console.log(`batchData?.ri_si_lc ... ${batchData?.ri_si_lc}`);
        // console.log(`batchData?.ri_premium_fc ... ${batchData?.ri_premium_fc}`);
        // console.log(`batchData?.ri_premium_lc ... ${batchData?.ri_premium_lc}`);

        setOsPercent(100 - allocationPercentage);
        setOsFcSi(batchData?.ri_si_fc - totalAllocatedFcSi);
        setOsLcSi(batchData?.ri_si_lc - totalAllocatedLcSi);
        setOsFcPremium(batchData?.ri_premium_fc - totalAllocatedFcPremium);
        setOsLcPremium(batchData?.ri_premium_lc - totalAllocatedLcPremium);

        if ((100 - allocationPercentage) !== 0 ||
            (batchData?.ri_si_lc - totalAllocatedLcSi) !== 0 ||
            (batchData?.ri_premium_lc - totalAllocatedLcPremium) !== 0
        ) {
            setOsFlag("Y");
        } else {
            setOsFlag("N");
        }

        // Calculate Retention
        const {
            totalRetentionFcSi,
            totalRetentionLcSi,
            totalRetentionFcPremium,
            totalRetentionLcPremium,
        } = batchLinesData
            ?.filter((line) => line.line_type === "Retention")
            ?.reduce(
                (totals, line) => {
                    totals.totalRetentionFcSi += formatStringToNumberV2(line.line_si_fc) || 0;
                    totals.totalRetentionLcSi += formatStringToNumberV2(line.line_si_lc) || 0;
                    totals.totalRetentionFcPremium += formatStringToNumberV2(line.line_premium_fc) || 0;
                    totals.totalRetentionLcPremium += formatStringToNumberV2(line.line_premium_lc) || 0;
                    return totals;
                },
                {
                    totalRetentionFcSi: 0,
                    totalRetentionLcSi: 0,
                    totalRetentionFcPremium: 0,
                    totalRetentionLcPremium: 0,
                }
            ) || {};

        const retentionPercentage = Number(parseFloat(calculateBasePercentage(batchData?.ri_si_lc, totalRetentionLcSi).toFixed(6)));
        setRetentionPercent(retentionPercentage);
        setRetentionFcSi(totalRetentionFcSi);
        setRetentionLcSi(totalRetentionLcSi);
        setRetentionFcPremium(totalRetentionFcPremium);
        setRetentionLcPremium(totalRetentionLcPremium);


        // Calculate CQS
        const {
            totalCqsFcSi,
            totalCqsLcSi,
            totalCqsFcPremium,
            totalCqsLcPremium,
        } = batchLinesData
            ?.filter((line) => line.line_type === "CQS")
            ?.reduce(
                (totals, line) => {
                    totals.totalCqsFcSi += formatStringToNumberV2(line.line_si_fc) || 0;
                    totals.totalCqsLcSi += formatStringToNumberV2(line.line_si_lc) || 0;
                    totals.totalCqsFcPremium += formatStringToNumberV2(line.line_premium_fc) || 0;
                    totals.totalCqsLcPremium += formatStringToNumberV2(line.line_premium_lc) || 0;
                    return totals;
                },
                {
                    totalCqsFcSi: 0,
                    totalCqsLcSi: 0,
                    totalCqsFcPremium: 0,
                    totalCqsLcPremium: 0,
                }
            ) || {};

        const cqsPercentage = Number(parseFloat(calculateBasePercentage(batchData?.ri_si_lc, totalCqsLcSi).toFixed(6)));
        setCqsPercent(cqsPercentage);
        setCqsFcSi(totalCqsFcSi);
        setCqsLcSi(totalCqsLcSi);
        setCqsFcPremium(totalCqsFcPremium);
        setCqsLcPremium(totalCqsLcPremium);


        // Calculate QS
        const {
            totalQsFcSi,
            totalQsLcSi,
            totalQsFcPremium,
            totalQsLcPremium,
        } = batchLinesData
            ?.filter((line) => line.line_type === "QS")
            ?.reduce(
                (totals, line) => {
                    totals.totalQsFcSi += formatStringToNumberV2(line.line_si_fc) || 0;
                    totals.totalQsLcSi += formatStringToNumberV2(line.line_si_lc) || 0;
                    totals.totalQsFcPremium += formatStringToNumberV2(line.line_premium_fc) || 0;
                    totals.totalQsLcPremium += formatStringToNumberV2(line.line_premium_lc) || 0;
                    return totals;
                },
                {
                    totalQsFcSi: 0,
                    totalQsLcSi: 0,
                    totalQsFcPremium: 0,
                    totalQsLcPremium: 0,
                }
            ) || {};


        const qsPercentage = Number(parseFloat(calculateBasePercentage(batchData?.ri_si_lc, totalQsLcSi).toFixed(6)));
        setQsPercent(qsPercentage);
        setQsFcSi(totalQsFcSi);
        setQsLcSi(totalQsLcSi);
        setQsFcPremium(totalQsFcPremium);
        setQsLcPremium(totalQsLcPremium);

        // Calculate FAC
        const {
            totalFacFcSi,
            totalFacLcSi,
            totalFacFcPremium,
            totalFacLcPremium,
        } = batchLinesData
            ?.filter((line) => line.line_type === "FAC")
            ?.reduce(
                (totals, line) => {
                    totals.totalFacFcSi += formatStringToNumberV2(line.line_si_fc) || 0;
                    totals.totalFacLcSi += formatStringToNumberV2(line.line_si_lc) || 0;
                    totals.totalFacFcPremium += formatStringToNumberV2(line.line_premium_fc) || 0;
                    totals.totalFacLcPremium += formatStringToNumberV2(line.line_premium_lc) || 0;
                    return totals;
                },
                {
                    totalFacFcSi: 0,
                    totalFacLcSi: 0,
                    totalFacFcPremium: 0,
                    totalFacLcPremium: 0,
                }
            ) || {};


        const facPercentage = Number(parseFloat(calculateBasePercentage(batchData?.ri_si_lc, totalFacLcSi).toFixed(6)));
        setFacPercent(facPercentage);
        setFacFcSi(totalFacFcSi);
        setFacLcSi(totalFacLcSi);
        setFacFcPremium(totalFacFcPremium);
        setFacLcPremium(totalFacLcPremium);


        // Calculate Surplus
        const surplusTypes = ["Surplus 1", "Surplus 2", "Surplus 3", "Surplus 4", "Surplus 5"];

        const {
            totalSurplusFcSi,
            totalSurplusLcSi,
            totalSurplusFcPremium,
            totalSurplusLcPremium,
        } = batchLinesData
            ?.filter((line) => surplusTypes.includes(line.line_type))
            ?.reduce(
                (totals, line) => {
                    totals.totalSurplusFcSi += formatStringToNumberV2(line.line_si_fc) || 0;
                    totals.totalSurplusLcSi += formatStringToNumberV2(line.line_si_lc) || 0;
                    totals.totalSurplusFcPremium += formatStringToNumberV2(line.line_premium_fc) || 0;
                    totals.totalSurplusLcPremium += formatStringToNumberV2(line.line_premium_lc) || 0;
                    return totals;
                },
                {
                    totalSurplusFcSi: 0,
                    totalSurplusLcSi: 0,
                    totalSurplusFcPremium: 0,
                    totalSurplusLcPremium: 0,
                }
            ) || {};


        const surplusPercentage = Number(parseFloat(calculateBasePercentage(batchData?.ri_si_lc, totalSurplusLcSi).toFixed(6)));
        setSurplusPercent(surplusPercentage);
        setSurplusFcSi(totalSurplusFcSi);
        setSurplusLcSi(totalSurplusLcSi);
        setSurplusFcPremium(totalSurplusFcPremium);
        setSurplusLcPremium(totalSurplusLcPremium);

    }, [batchLinesData]);

    useEffect(() => {
        if (docid !== undefined) {
            fetchBatch(docid, true);
        }
    }, [docid]);


    return (
        <motion.div
            className="ri-batch"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
        >
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
                        color="var(--primary)"
                        height={50}
                        radius={8}
                        width={4}
                    />
                </div>
            ) : (
                <div className="ri-batch-main-wrapper">
                    <div className="navbar">
                        <div className="navbar-left">
                            <h1 className="page-title"> {batchData?.ri_batch_no}</h1>
                        </div>
                        <div className="navbar-right">
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                endIcon={<LuRefreshCcw />}
                                borderRadiusType="both"
                                variant="tint"
                                color="#0f766e5d"
                                onClick={async () => await fetchBatch(docid)}
                            >
                                {t('refresh')}
                            </CustomLoadingButton>
                            {nextAction !== "None" &&
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="both"
                                    variant="tint"
                                    color="#1E88E5"
                                    endIcon={<BiLogoRedux />}
                                    onClick={() => {
                                        setConfirmationActiontext(`Do you want to re-allocate ${batchData?.ri_batch_no}?. Please note current allocation will be deleated`);
                                        setConfirmDialogAction("reallocateRi");
                                        setIsConfirmDialogOpen(true);
                                    }}
                                >
                                    {t('reallocate')}
                                </CustomLoadingButton>}
                            {saveEnabled === "Y" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="both"
                                    variant="tint"
                                    color="#00D37F"
                                    tooltip="Save changes"
                                    endIcon={<MdSave />}
                                    onClick={saveRecord}>
                                    {t('save')}
                                </CustomLoadingButton>
                            )}
                            {docid !== "new" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="both"
                                    variant="tint"
                                    color="#2563EB"
                                    tooltip="Run reports for this document"
                                    endIcon={<IoDocumentTextSharp />}
                                    onClick={() => setReportsDialogOpen(true)}>
                                    {t('reports')}
                                </CustomLoadingButton>
                            )}
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="both"
                                variant="tint"
                                color="#f55656"
                                tooltip="Close this document"
                                endIcon={<MdClose />}
                                onClick={() => navigate(-1)}>
                                {t('close')}
                            </CustomLoadingButton>
                        </div>
                    </div>
                    <div className="content-summary-wrapper">
                        <div className="ribatch-content-wrapper">
                            <ExpandableComponent
                                title={t('details').toUpperCase()}
                                subtitle={
                                    <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                                        <span className={`status ${batchData?.ri_status}`}>{`${t('status').toUpperCase()} ${batchData?.ri_status}`}</span>
                                        <Select
                                            id="risk_category"
                                            name="risk_category"
                                            menuPortalTarget={document.body}
                                            styles={{
                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                menuPortal: base => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                })
                                            }}
                                            width="150px"
                                            value={riCategories?.find(option => option.value === batchData?.ri_risk_catg) || null}
                                            onChange={(opt) => { setBatchData((p) => ({ ...p, ri_risk_catg: opt?.value })); }}
                                            isSearchable
                                            options={riCategories}
                                            placeholder={t('category').toUpperCase()}
                                        />
                                    </div>
                                }
                                defaultExpanded={true}
                            >
                                <div className="policy-details-wrapper">
                                    <div className="policy-details-form">
                                        <div className="policy-details-left lg">
                                            <div className="item-value">
                                                <span className="label">{t('batchNo').toUpperCase()}</span>
                                                <span className="value">{batchData?.ri_batch_no}</span>
                                            </div>
                                            <div className="item-value">
                                                <span className="label">{t('policyNo').toUpperCase()}</span>
                                                <span className="value">{batchData?.ri_policy_no}</span>
                                            </div>
                                            <div className="item-value">
                                                <span className="label">{t('endorsementNo').toUpperCase()}</span>
                                                <span className="value">{batchData?.ri_endorsement_no}</span>
                                            </div>
                                        </div>
                                        <div className="policy-details-center sm">
                                            <div className="item-value">
                                                <span className="label">{t('risk').toUpperCase()}</span>
                                                <span className="value">{batchData?.ri_risk_code}</span>
                                            </div>
                                            <div className="item-value">
                                                <span className="label">{t('category').toUpperCase()}</span>
                                                <span className="value">{batchData?.ri_risk_catg}</span>
                                            </div>
                                            <div className="item-value">
                                                <span className="label">{t('mode').toUpperCase()}</span>
                                                <span className="value">{batchData?.ri_allocation_mode}</span>
                                            </div>
                                        </div>
                                        <div className="policy-details-right lg">
                                            <div className="item-value">
                                                <span className="label">{t('treaty').toUpperCase()}</span>
                                                <span className="value">{batchData?.ri_treaty_code}</span>
                                            </div>
                                            <div className="item-value">
                                                <span className="label">{t('glDate').toUpperCase()}</span>
                                                <span className="value">{batchData?.formatted_gldate_xx}</span>
                                            </div>
                                            <div className="item-value">
                                                <span className="label">{t('channel').toUpperCase()}</span>
                                                <span className="value">{batchData?.pl_channel_xx}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="separator-h" />
                                    <div className="policy-details-form">
                                        <div className="policy-details-left lg">
                                            <span className="label">{t('insured').toUpperCase()}</span>
                                            <span className="value">{batchData?.pl_assr_name_xx}</span>
                                            <span className="value">{batchData?.pl_assr_ent_code}</span>
                                            <span className="value">{`${t('phoneNo')}: ${batchData?.pl_assr_phone_no_xx}`}</span>
                                            <span className="value">{`${t('email')}: ${batchData?.pl_assr_email_xx}`}</span>
                                        </div>


                                        <div className="policy-details-center sm">
                                            <span className="label">{t('period').toUpperCase()}</span>
                                            <span className="value">{`${t('from').toUpperCase()} : ${batchData?.fmt_to_date}`}</span>
                                            <span className="value">{`${t('to').toUpperCase()} : ${batchData?.fmt_to_date}`}</span>
                                            <span className="value">{`${t('days').toUpperCase()} : ${batchData?.difference_in_days}`}</span>
                                            <span className="value">BOTH DATES INCLUSIVE</span>
                                        </div>
                                        <div className="policy-details-right lg">
                                            <span className="label">{t('intermediary').toUpperCase()}</span>
                                            <span className="value">{batchData?.pl_ins_name_xx}</span>
                                            <span className="value">{batchData?.pl_ins_ent_code}</span>
                                            <span className="value">{`${t('phoneNo')} : ${batchData?.pl_ins_phone_no_xx}`}</span>
                                            <span className="value">{`${t('email')}: ${batchData?.pl_ins_email_xx}`}</span>
                                        </div>
                                    </div>
                                    <hr className="separator-h" />
                                    <div className="policy-details-form">
                                        <div className="policy-details-left lg" >
                                            <span className="label">{t('location').toUpperCase()}</span>
                                            {/* <span className="value">{`BIZ UNIT: ${batchData?.pl_biz_unit_xx} [${batchData?.pl_biz_unit}]`}</span>
                                            <span className="value">{`CLASS: ${batchData?.ri_mc_code_xx} [${batchData?.ri_mc_code}]`}</span>
                                            <span className="value">{`SUB CLASS: ${batchData?.ri_sc_code_xx} [${batchData?.ri_sc_code}]`}</span>
                                            <span className="value">{`COVER: ${batchData?.ri_cc_code_xx} [${batchData?.ri_cc_code}]`}</span> */}

                                            <div className="item-value">
                                                <span className="label">{t('bizUnit').toUpperCase()}</span>
                                                <span className="value">{`${batchData?.pl_biz_unit_xx} [${batchData?.pl_biz_unit}]`}</span>
                                            </div>
                                            <div className="item-value">
                                                <span className="label">{t('class').toUpperCase()}</span>
                                                <span className="value">{`${batchData?.ri_mc_code_xx} [${batchData?.ri_mc_code}]`}</span>
                                            </div>
                                            <div className="item-value">
                                                <span className="label">{t('subClass').toUpperCase()}</span>
                                                <span className="value">{`${batchData?.ri_sc_code_xx} [${batchData?.ri_sc_code}]`}</span>
                                            </div>
                                            <div className="item-value">
                                                <span className="label">{t('cover').toUpperCase()}</span>
                                                <span className="value">{`${batchData?.ri_cc_code_xx} [${batchData?.ri_cc_code}]`}</span>
                                            </div>
                                        </div>
                                        <div className="policy-details-center lg" style={{ alignItems: "flex-end" }}>
                                            <span className="label">{t('details').toUpperCase()}</span>
                                            <div className="item-value">
                                                <span className="label">{t('product').toUpperCase()}</span>
                                                <span className="value">{`${batchData?.ri_pr_code_xx} [${batchData?.ri_pr_code}]`}</span>
                                            </div>
                                            <div className="item-value">
                                                <span className="label">{t('class').toUpperCase()}</span>
                                                <span className="value">{`${batchData?.ri_mc_code_xx} [${batchData?.ri_mc_code}]`}</span>
                                            </div>
                                            <div className="item-value">
                                                <span className="label">{t('subClass').toUpperCase()}</span>
                                                <span className="value">{`${batchData?.ri_sc_code_xx} [${batchData?.ri_sc_code}]`}</span>
                                            </div>
                                            <div className="item-value">
                                                <span className="label">{t('cover').toUpperCase()}</span>
                                                <span className="value">{`${batchData?.ri_cc_code_xx} [${batchData?.ri_cc_code}]`}</span>
                                            </div>
                                        </div>
                                        {/* <div className="policy-details-right sm" style={{ alignItems: "flex-end" }}>
                                            <span className="label">{`${t('amounts').toUpperCase()} [${batchData?.pl_cur_code}]`}</span>
                                            <div className="item-value">
                                                <span className="label">{t('si').toUpperCase()}</span>
                                                <span className="value">{numeral(batchData?.ri_si_lc).format("0,0.00")}</span>
                                            </div>
                                            <div className="item-value">
                                                <span className="label">{t('premium').toUpperCase()}</span>
                                                <span className="value">{numeral(batchData?.ri_premium_lc).format("0,0.00")}</span>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </ExpandableComponent>
                            <ExpandableComponent
                                title={t('lines').toUpperCase()}
                                subtitle={
                                    osFlag === "Y" && (
                                        <CustomLoadingButton
                                            currentTheme={currentTheme}
                                            iconPosition="end"
                                            borderRadiusType="both"
                                            variant="tint"
                                            color="#0ea5a4"
                                            tooltip={"Add Facultative"}
                                            endIcon={<IoDocumentTextSharp />}
                                            onClick={async () => {
                                                try {

                                                    const retentionLine = batchLinesData.filter(item => {
                                                        const desc = item.line_type.replace(/\s+/g, "").toLowerCase();
                                                        return desc === "retention";
                                                    });
                                                    logData("retentionLine", retentionLine);

                                                    if (!retentionLine) {
                                                        setNotifyDialogTitle(t('note'));
                                                        setNotifyDialogText('Retention line not found');
                                                        setIsNotifyDialogOpen(true);
                                                        return;
                                                    }

                                                    const res = await newRequest.post("/ribatch/addBatchLine",
                                                        {
                                                            line_batch_no: batchData?.ri_batch_no,
                                                            line_type: "FAC",
                                                            line_limit_docid: retentionLine[0]?.line_limit_docid,
                                                            line_treaty_code: batchData?.ri_treaty_code,
                                                            line_rate: osPercent,
                                                            line_si_fc: osFcSi,
                                                            line_si_lc: osLcSi,
                                                            line_premium_fc: osFcPremium,
                                                            line_premium_lc: osLcPremium,
                                                            line_limit: osFcSi,
                                                            line_count: 1,
                                                            line_capacity: osFcSi,
                                                            line_start_si_fc: osFcSi,
                                                            line_start_si_lc: osLcSi,
                                                            line_end_si_fc: 0,
                                                            line_end_si_lc: 0,
                                                        });

                                                    if (res.data?.msg === "added") {
                                                        const newLine = res.data?.doc;
                                                        const formattedLine = {
                                                            ...newLine,
                                                            line_si_fc: formatNumber(newLine.line_si_fc, 2),
                                                            line_si_lc: formatNumber(newLine.line_si_lc, 2),
                                                            line_premium_fc: formatNumber(newLine.line_premium_fc, 2),
                                                            line_premium_lc: formatNumber(newLine.line_premium_lc, 2),
                                                            line_rate: formatNumber(newLine.line_rate, 6),
                                                        };
                                                        setBatchLinesData((prevParams) => [...prevParams, formattedLine]);
                                                        showToast("Added!", "success");
                                                    } else if (res.data?.msg === "exists") {
                                                        showToast(`FAC already exists`, "warning");
                                                    } else {
                                                        showToast("Error adding line!", "error");
                                                    }
                                                } catch (error) {
                                                    console.log(error);
                                                }
                                            }}>
                                            {t('addFac')}
                                        </CustomLoadingButton>
                                    )
                                }
                                defaultExpanded={true}
                            >
                                <div className="available-services">
                                    <div className="table-content">
                                        <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                            <Table sx={{ width: "max-content", border: 'none' }}>
                                                <TableHead className="tablehead">
                                                    <TableRow className="tablerow">
                                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                            #
                                                        </TableCell>
                                                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                            <span>{t('lineType').toUpperCase()}</span>
                                                        </TableCell>
                                                        <TableCell className="table-cell right" style={{ maxWidth: "170px" }}>
                                                            <span>{`${t('sumInsured').toUpperCase()} [${currentUser?.currency_code_xx}]`}</span>
                                                        </TableCell>
                                                        <TableCell className="table-cell right" style={{ maxWidth: "170px" }}>
                                                            <span>{`${t('premium').toUpperCase()} [${currentUser?.currency_code_xx}]`}</span>
                                                        </TableCell>
                                                        <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                                            <span>{t('perc').toUpperCase()}</span>
                                                        </TableCell>
                                                        <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                            <span>{`${t('capacity').toUpperCase()} [${currentUser?.currency_code_xx}]`}</span>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody className="tablebody">
                                                    {batchLinesData?.map((row, index) => (
                                                        <TableRow
                                                            key={row?._id}
                                                            className={`${selectedBatchLine?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                                            onClick={() => setSelectedBatchLine(row)}
                                                        >
                                                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                                <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", width: "100%" }}>
                                                                    <span className="sub-title">{row.line_type}</span>
                                                                    {batchData?.ri_status === "New" &&
                                                                        row.line_type === "FAC" &&
                                                                        <CircularButton
                                                                            currentTheme={currentTheme}
                                                                            color="#E53935"
                                                                            onClick={(e) => {
                                                                                try {
                                                                                    e.stopPropagation();
                                                                                    setSelectedBatchLine(row);
                                                                                    setConfirmationActiontext(`Do you want to remove ${row.line_type}?`);
                                                                                    setConfirmDialogAction("deleteLine");
                                                                                    setIsConfirmDialogOpen(true);
                                                                                } catch (error) {
                                                                                    console.log(error);
                                                                                }
                                                                            }}
                                                                            icon={<MdDelete />}
                                                                            width={"30px"}
                                                                            height={"30px"} />}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className="table-cell right" style={{ maxWidth: "170px" }}>
                                                                {batchData?.ri_status === "New" ?
                                                                    <div className="input-item-with-label">
                                                                        <input
                                                                            id="line_si_lc"
                                                                            name="line_si_lc"
                                                                            type="text"
                                                                            value={row.line_si_lc}
                                                                            onChange={(e) => handleLineInputChange(e, row._id, 'line_si_lc')}
                                                                            onBlur={() => handleLineBlur(row._id, "line_si_lc")}
                                                                            style={{ width: "100%", textAlign: "right" }}
                                                                            className="form-input-item table"
                                                                        />
                                                                    </div>
                                                                    :
                                                                    <span className="sub-title">{numeral(row.line_si_lc).format("0,0.00")}</span>}
                                                            </TableCell>
                                                            <TableCell className="table-cell right" style={{ maxWidth: "170px" }}>
                                                                {batchData?.ri_status === "New" ?
                                                                    <div className="input-item-with-label">
                                                                        <input
                                                                            id="line_premium_lc"
                                                                            name="line_premium_lc"
                                                                            type="text"
                                                                            value={row.line_premium_lc}
                                                                            onChange={(e) => handleLineInputChange(e, row._id, 'line_premium_lc')}
                                                                            onBlur={() => handleLineBlur(row._id, "line_premium_lc")}
                                                                            style={{ width: "100%", textAlign: "right" }}
                                                                            className="form-input-item table"
                                                                        />
                                                                    </div>
                                                                    :
                                                                    <span className="sub-title">{numeral(row.line_premium_lc).format("0,0.00")}</span>}
                                                            </TableCell>
                                                            <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                                                <span className="sub-title">{numeral(row.line_rate).format("0.000000")}</span>
                                                            </TableCell>
                                                            <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                                <span className="sub-title">{numeral(row.line_capacity).format("0,0.00")}</span>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </div>
                            </ExpandableComponent>
                        </div>
                        <div className="ribatch-summary-wrapper">
                            <div className="worked-on-by-container">
                                <div className="panel-card" style={{ padding: "10px" }}>
                                    <WorkedOnBy
                                        name={batchData?.updated_by_name_xx}
                                        photoUrl={batchData?.updated_by_photo_url_xx}
                                        time_ago_xx={batchData?.time_ago_xx}
                                    />
                                </div>
                            </div>
                            <div className="ribatch-summary-content">

                                {/* ===================== SUMMARY CARD ===================== */}
                                <div className="panel-card">
                                    <div className="panel-card__header">
                                        <div className="panel-card__titleRow">
                                            <h1 className="panel-card__title">{t("summary").toUpperCase()}</h1>
                                            <span className="panel-card__currency">{batchData?.pl_cur_code}</span>
                                        </div>
                                        <div className="panel-card__divider" />
                                    </div>

                                    <div className="panel-card__body">
                                        <div className="kv-row">
                                            <span className="kv-key">{t("sumInsured").toUpperCase()}</span>
                                            <span className="kv-val">{numeral(batchData?.ri_si_lc).format("0,0.00")}
                                            </span>
                                        </div>

                                        <div className="kv-row">
                                            <span className="kv-key">{t("premium").toUpperCase()}</span>
                                            <span className="kv-val">
                                                {numeral(batchData?.ri_premium_lc).format("0,0.00")}
                                            </span>
                                        </div>
                                        <div className="pill-row pill-row--success">
                                            <span className="pill-label">{t("totalPremium").toUpperCase()}</span>
                                            <span className="pill-value">{numeral(batchData?.ri_premium_lc).format("0,0.00")}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="panel-card__divider" />
                                    <div className="panel-card__header">
                                        <div className="panel-card__titleRow">
                                            <h1 className="panel-card__title">{t("allocated").toUpperCase()}</h1>
                                            <span className="panel-card__currency">{`${numeral((allocatedPercent || 0)).format("0.000000")}%`}</span>
                                        </div>
                                    </div>
                                    <div className="panel-card__body">
                                        <div className="kv-row">
                                            <span className="kv-key">{t("sumInsured").toUpperCase()}</span>
                                            <span className="kv-val">{numeral(allocatedLcSi).format("0,0.00")}
                                            </span>
                                        </div>
                                        <div className="kv-row">
                                            <span className="kv-key">{t("premium").toUpperCase()}</span>
                                            <span className="kv-val">{numeral(allocatedLcPremium).format("0,0.00")}
                                            </span>
                                        </div>
                                    </div>
                                    {/* OUTSTANDING */}
                                    <div className="panel-card__body" style={{ padding: "-10px 0px -12px 0px" }}>
                                        <div className={osPercent > 0 ? "outstanding--danger" : "outstanding--success"}>
                                            <div className="panel-card__header">
                                                <div className="panel-card__titleRow">
                                                    <h1 className="kv-key">{t("outstanding").toUpperCase()}</h1>
                                                    <span className="kv-val">{`${numeral((osPercent || 0)).format("0.000000")}%`}</span>
                                                </div>
                                            </div>
                                            <div className="panel-card__body">
                                                <div className="kv-row">
                                                    <span className="kv-key">{t("sumInsured").toUpperCase()}</span>
                                                    <span className="kv-val">{numeral(osLcSi).format("0,0.00")}
                                                    </span>
                                                </div>
                                                <div className="kv-row">
                                                    <span className="kv-key">{t("premium").toUpperCase()}</span>
                                                    <span className="kv-val">{numeral(osLcPremium).format("0,0.00")}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="panel-card__divider" />


                                    <div className="panel-card__header">
                                        <div className="panel-card__titleRow">
                                            <h1 className="panel-card__title">{t("breakdown").toUpperCase()}</h1>
                                        </div>
                                    </div>

                                    {/* RETENTION */}
                                    <div className="panel-card__header">
                                        <div className="panel-card__titleRow">
                                            <h1 className="panel-card__title">{t("retention").toUpperCase()}</h1>
                                            <span className="panel-card__currency">{`${numeral((retentionPercent || 0)).format("0.000000")}%`}</span>
                                        </div>
                                    </div>
                                    <div className="panel-card__body">
                                        <div className="kv-row">
                                            <span className="kv-key">{t("sumInsured").toUpperCase()}</span>
                                            <span className="kv-val">
                                                {numeral(retentionLcSi).format("0,0.00")}
                                            </span>
                                        </div>
                                        <div className="kv-row">
                                            <span className="kv-key">{t("premium").toUpperCase()}</span>
                                            <span className="kv-val">{numeral(retentionLcPremium).format("0,0.00")}
                                            </span>
                                        </div>
                                    </div>
                                    {/* CQS */}
                                    <div className="panel-card__header">
                                        <div className="panel-card__titleRow">
                                            <h1 className="panel-card__title">{t("cqs").toUpperCase()}</h1>
                                            <span className="panel-card__currency">{`${numeral((cqsPercent || 0)).format("0.000000")}%`}</span>
                                        </div>
                                    </div>
                                    <div className="panel-card__body">
                                        <div className="kv-row">
                                            <span className="kv-key">{t("sumInsured").toUpperCase()}</span>
                                            <span className="kv-val"> {numeral(cqsLcSi).format("0,0.00")}
                                            </span>
                                        </div>
                                        <div className="kv-row">
                                            <span className="kv-key">{t("premium").toUpperCase()}</span>
                                            <span className="kv-val">   {numeral(cqsLcPremium).format("0,0.00")}
                                            </span>
                                        </div>
                                    </div>
                                    {/* QS */}
                                    <div className="panel-card__header">
                                        <div className="panel-card__titleRow">
                                            <h1 className="panel-card__title">{t("qs").toUpperCase()}</h1>
                                            <span className="panel-card__currency">{`${numeral((qsPercent || 0)).format("0.000000")}%`}</span>
                                        </div>
                                    </div>
                                    <div className="panel-card__body">
                                        <div className="kv-row">
                                            <span className="kv-key">{t("sumInsured").toUpperCase()}</span>
                                            <span className="kv-val">
                                                {numeral(qsLcSi).format("0,0.00")}
                                            </span>
                                        </div>
                                        <div className="kv-row">
                                            <span className="kv-key">{t("premium").toUpperCase()}</span>
                                            <span className="kv-val">
                                                {numeral(qsLcPremium).format("0,0.00")}
                                            </span>
                                        </div>
                                    </div>
                                    {/* SURPLUS */}
                                    <div className="panel-card__header">
                                        <div className="panel-card__titleRow">
                                            <h1 className="panel-card__title">{t("surplus").toUpperCase()}</h1>
                                            <span className="panel-card__currency">{`${numeral((surplusPercent || 0)).format("0.000000")}%`}</span>
                                        </div>
                                    </div>
                                    <div className="panel-card__body">
                                        <div className="kv-row">
                                            <span className="kv-key">{t("sumInsured").toUpperCase()}</span>
                                            <span className="kv-val">
                                                {numeral(surplusLcSi).format("0,0.00")}
                                            </span>
                                        </div>
                                        <div className="kv-row">
                                            <span className="kv-key">{t("premium").toUpperCase()}</span>
                                            <span className="kv-val">
                                                {numeral(surplusLcPremium).format("0,0.00")}
                                            </span>
                                        </div>
                                    </div>
                                    {/* FAC */}
                                    <div className="panel-card__header">
                                        <div className="panel-card__titleRow">
                                            <h1 className="panel-card__title">{t("fac").toUpperCase()}</h1>
                                            <span className="panel-card__currency">{`${numeral((facPercent || 0)).format("0.000000")}%`}</span>
                                        </div>
                                    </div>
                                    <div className="panel-card__body">
                                        <div className="kv-row">
                                            <span className="kv-key">{t("sumInsured").toUpperCase()}</span>
                                            <span className="kv-val">
                                                {numeral(facLcSi).format("0,0.00")}
                                            </span>
                                        </div>
                                        <div className="kv-row">
                                            <span className="kv-key">{t("premium").toUpperCase()}</span>
                                            <span className="kv-val">
                                                {numeral(facLcPremium).format("0,0.00")}
                                            </span>
                                        </div>
                                    </div>
                                    {/* OUTSTANDING */}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={() => setIsNotifyDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton currentTheme={currentTheme} onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={() => setIsConfirmDialogOpen(false)}
                onConfirm={handleConfirm}
                dialogTitle={t('confirmation')}
                dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
            />
            {/* email component */}
            {emailDialogOpen && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{t('email').toUpperCase()}</h1>
                            <CircularButton currentTheme={currentTheme} onClick={() => setEmailDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <EmailComponent setEmailDialogOpen={setEmailDialogOpen} emailData={emailData} />
                        </div>
                    </div>
                </motion.div>
            )}
            {reportsDialogOpen && (
                <motion.div
                    className="overlay-dialog reports"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{t('reports')}</h1>
                            <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <OnScreenReports
                                reportGroupArray={batchData?.report_keys_array}
                                documentData={{
                                    docNo: "",
                                    docType: "RI Batch",
                                    docId: docid,
                                    clientEmail: batchData?.client_email_xx,
                                    clientEntCode: "",
                                    clientEntName: ""
                                }} />
                        </div>
                    </div>
                </motion.div>
            )}
            {isProcessing && (
                <motion.div
                    className="processing-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="processing-wrapper">
                        <ScaleLoader
                            color="var(--primary)"
                            height={50}
                            radius={8}
                            width={4}
                        />
                    </div>
                </motion.div>
            )}
        </motion.div >
    )
};

export default RiBatch